import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _getFeedbackFormSettings;
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { fetchGetFeedbackFormSettings } from '../../Repositories/feedback-form/v1/get-feedback-form-settings';
import { DEFAULT_LINK_MODEL, DEFAULT_ERROR_MESSAGE } from './constants';
export function getFeedbackFormSettings(_x, _x2) {
  return (_getFeedbackFormSettings = _getFeedbackFormSettings || _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(context, parameters) {
    var httpApi, logger, getFeedbackFormSettingsResponse, errorMessage;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          httpApi = context.httpApi, logger = context.logger;
          _context.prev = 1;
          _context.next = 4;
          return fetchGetFeedbackFormSettings({
            httpApi: httpApi,
            parameters: parameters
          });
        case 4:
          getFeedbackFormSettingsResponse = _context.sent;
          if (!(getFeedbackFormSettingsResponse.statusCode !== 200)) {
            _context.next = 9;
            break;
          }
          errorMessage = getFeedbackFormSettingsResponse.response.message || DEFAULT_ERROR_MESSAGE;
          logger.warning("[Degradation] fetchGetModerationIssues: ".concat(errorMessage));
          return _context.abrupt("return", DEFAULT_LINK_MODEL);
        case 9:
          return _context.abrupt("return", {
            model: getFeedbackFormSettingsResponse.response.model
          });
        case 12:
          _context.prev = 12;
          _context.t0 = _context["catch"](1);
          logger.error(_context.t0);
          return _context.abrupt("return", DEFAULT_LINK_MODEL);
        case 16:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 12]]);
  }))).apply(this, arguments);
}